export const POPUP_A11Y_REGISTER_KEY = 'registerPopupA11y';
